import getDayKey from "./getDayKey"
import getMomentDateObj from "./getMomentDateObj"
import getShowtimeKey from "./getShowtimeKey"

const checkForQuickTicketSelectOptions = (currentMovieDate, currentMovieShowtime, currentCinema, performance, dateNow, timezone) => {
    let hasAttribute = []
    const performanceCinema = performance.cinema
    const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
    const dayKey = getDayKey(performanceDate)
    const showtimeKey  = getShowtimeKey(performanceDate)

    if(dateNow.isBefore(performanceDate)) {
        if(currentMovieShowtime !== '') {
            if (showtimeKey === currentMovieShowtime) {
                hasAttribute.push('true')
            } else {
                hasAttribute.push('false')
            }
        } 
        
        if (currentMovieDate !== '') {
            if(currentMovieDate === dayKey) {
                hasAttribute.push('true')
            } else {
                hasAttribute.push('false')
            }

        }
        
        if (currentCinema !== '') {
            if(performanceCinema === currentCinema) {
                hasAttribute.push('true')
            } else {
                hasAttribute.push('false')
            }
        }
    }

    return hasAttribute
}

export default checkForQuickTicketSelectOptions